import React from 'react';

import request from 'services/request';

import Article from 'grommet/components/Article';
import Heading from 'grommet/components/Heading';
import Footer from 'grommet/components/Footer';
import Form from 'grommet/components/Form';
import Button from 'grommet/components/Button';
import Anchor from 'grommet/components/Anchor';
import FormField from 'grommet/components/FormField';
import Notification from 'grommet/components/Notification';

import TextInput from 'elements/TextInput';

export default class ForgotPassword extends React.Component {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      errors: {},
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const errors = {};
    if (!this.state.password) errors.password = 'Required';
    if (!this.state.password_confirmation) errors.password_confirmation = 'Required';
    if (this.state.password !== this.state.password_confirmation) errors.password = 'Passwords do not match';

    if (Object.keys(errors).length) {
      return this.setState({ errors });
    }
    request({
      method: 'POST',
      url: '/api/reset-password',
      body: {
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
        token: this.props.params.token,
      }
    })
      .then((res) => {
        this.setState({
          password: '',
          password_confirmation: '',
          notification: {
            message:<div>Your password has been reset. You may now <Anchor path="/login">log in</Anchor>.</div>,
            status: 'ok',
          },
        })
      })
      .catch(res => {
        this.setState({
          notification: {
            message:'Oops. Something went wrong. Check the link we sent and try again.',
            status: 'critical',
          },
        });
      });
  }

  render() {
    return (
      <Article align="center" full justify="center">
        <Form onSubmit={this.onSubmit}>
          <Heading tag="h1" strong>Reset your password</Heading>
          <Notification
            display-if={this.state.notification}
            status={this.state.notification.status}
            message={<div>Your password has been reset. You may now <Anchor path="/login">log in</Anchor>.</div>} />
            <FormField label="Password (min 8 characters)" error={this.state.errors.password}>
              <TextInput
                name="password"
                type="password"
                onChange={e => this.setState({ [e.target.name]: e.target.value, errors: {} })}
                value={this.state.password}/>
            </FormField>
            <FormField label="Confirm password" error={this.state.errors.password_confirmation}>
              <TextInput
                name="password_confirmation"
                type="password"
                onChange={e => this.setState({ [e.target.name]: e.target.value, errors: {} })}
                value={this.state.password_confirmation} />
            </FormField>
          <Footer pad={{vertical: 'medium', between: 'medium'}} direction="column" align="start">
            <Button onClick={this.onSubmit} type="submit" label="OK" primary />
            <Anchor path="/login" label="Go back"></Anchor>
          </Footer>
        </Form>
      </Article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js